import React from "react"
import { Control } from "react-hook-form"
import RadioButtons from "components/ReactHookForm/RadioButtons"
import { WalletPassBuilderFormValues } from "./walletPassBuilderTypes"

type Option = { label: string; value: string }

type Props = {
  name: keyof WalletPassBuilderFormValues
  control: Control<WalletPassBuilderFormValues>
  options: Option[]
}

// The default/override choice every main field shares. The inputs below it stay
// visible while the default is selected, greyed out rather than hidden, so the
// organizer can see what they would be overriding.
const PassBuilderFieldMode = ({ name, control, options }: Props) => (
  <RadioButtons
    name={name}
    control={control as any}
    options={options}
    horizontal
    optionWidth="auto"
    spacing={8}
    mb={0}
    alignItems="center"
  />
)

export default PassBuilderFieldMode
